import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { PlumaModal } from '@customerio/pluma-components/css/components';
import { fillScope } from '@customerio/pluma-components/css/utils';

/** The builder and the SQL sit side by side, so the modal takes the width of its body. */
export const modal = style(
  {
    vars: {
      [PlumaModal.vars.modalMinWidth]: 'initial',
      [PlumaModal.vars.modalMaxWidth]: 'min(1080px, calc(100vw - 32px))',
    },
  },
  'query-builder-modal',
);

export const body = style({ width: 'min(1080px, calc(100vw - 32px))' }, 'query-builder-body');

export const columns = style(
  {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.05fr) minmax(0, 1fr)',
    gap: themeVars.space['400'],
    alignItems: 'start',
    '@media': {
      'screen and (max-width: 860px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
    },
  },
  'query-builder-columns',
);

export const sqlPane = style(
  {
    margin: 0,
    minHeight: '280px',
    padding: themeVars.space['200'],
    borderRadius: themeVars.radius['4'],
    backgroundColor: themeVars.color['overlay-tint'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    fontFamily: themeVars['font-family'].mono,
    fontSize: themeVars.text['product-code-font-size'],
    lineHeight: themeVars.text['product-code-line-height'],
    color: themeVars.color['text-code'],
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  },
  'query-builder-sql',
);

export const sqlLine = style(
  {
    display: 'block',
    paddingInline: themeVars.space['050'],
    borderRadius: themeVars.radius['3'],
    minHeight: '1em',
  },
  'query-builder-sql-line',
);

// A line the agent's query did not have, so the customer sees what an edit does to the SQL.
// The bar at the start of the line marks it without relying on color alone (WCAG 1.4.1).
export const sqlLineChanged = style(
  {
    backgroundColor: fillScope('caution', 'subtle'),
    boxShadow: `inset 3px 0 0 ${themeVars.color['scope-caution-text']}`,
    paddingInlineStart: themeVars.space['100'],
  },
  'query-builder-sql-line-changed',
);

export const chips = style(
  {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: themeVars.space['100'],
  },
  'query-builder-chips',
);

export const filterRow = style(
  {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1fr) auto',
    gap: themeVars.space['100'],
    alignItems: 'center',
  },
  'query-builder-filter-row',
);

export const narrowField = style({ width: '96px' }, 'query-builder-narrow-field');
export const pickerField = style({ minWidth: '180px' }, 'query-builder-picker-field');
export const directionField = style({ width: '150px' }, 'query-builder-direction-field');
export const dateRangeField = style({ minWidth: '260px' }, 'query-builder-date-range-field');

// The remove button inside a chip: no chrome of its own, a hit area the size of the icon.
export const chipRemove = style(
  {
    display: 'inline-flex',
    alignItems: 'center',
    marginInlineStart: themeVars.space['050'],
    borderRadius: themeVars.radius['3'],
    color: themeVars.color['text-secondary'],
    ':hover': { color: themeVars.color['text-primary'] },
  },
  'query-builder-chip-remove',
);
